var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog"},[_c('div',{staticClass:"elfsight-app-0b842362-4c2a-4913-aae5-b20594c8c9ae"})])
}]

export { render, staticRenderFns }